/**
 * Object.assign, but ignores properties that are explicitly defined with an undefined value.
 */
export function assignDefined(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        for (var _b = 0, _c = Object.keys(source); _b < _c.length; _b++) {
            var key = _c[_b];
            var val = source[key];
            if (val !== undefined)
                target[key] = val;
        }
    }
    return target;
}
